<div class="mct-flex mct-col mct-gap-27"   *ngIf="affiliationCodeData">
  <div>
    <p-checkbox [(ngModel)]="affiliationCodeData.Required" name="required" [binary]="true" inputId="affiliationCodeRequired"> </p-checkbox>
    <label for="affiliationCodeRequired">
      {{ 'common.required' | translate | titlecase }}
    </label>
  </div>
  <div class="mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.affiliation-code.affiliation-type' | translate | ucfirst }} </label>
    <p-select
      name="affiliationType"
      appendTo="body"
      [style]="{ width: '100%' }"
      [options]="affCodeTypes"
      [(ngModel)]="affCodeTypeId"
      (onChange)="affCodeTypeChanged($event.value)"
      [placeholder]="'common.select-one' | translate | ucfirst"
      [required]="true"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.affiliation-code.title' | translate | ucfirst }} </label>
    <p-select
      name="affiliationCode"
      appendTo="body"
      [style]="{ width: '100%' }"
      [options]="affCodes"
      [(ngModel)]="affiliationCodeData.AffCode"
      (onChange)="affCodeChanged($event.value)"
      [placeholder]="'common.select-one' | translate | ucfirst"
      [required]="true"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.display-name' | translate | ucfirst }} </label>
    <input name="affiliationLabel" class="form-control" [(ngModel)]="affiliationCodeData.Label" />
  </div>
</div>
